module.exports = __webpack_public_path__ + "static/media/add indent form.dde9baf7.svg";